/*
 * @Author       : yiyang
 * @Date         : 2020-09-02 16:31:20
 * @LastEditors  : yiyang
 * @LastEditTime : 2020-10-29 17:10:08
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/routes/classifyList/Item.js
 * @URL          : 
 */
import './Item.css'
import React, { memo } from 'react'
// import { useHistory } from 'react-router-dom'
// import { getThemeColor } from 'utils/utils'
// import { COVER_PATH } from 'routes/path'
// import { GRAPHIC_PATH } from 'routes/path'
import NETImage from 'components/net-image'
// import IconFont from 'components/iconfont/IconFont'
import config from "config/default"

/**
 * 课程项
 */
export default memo(function classifyItem({ item, theme }) {
    // const history = useHistory()
    // const themeColor = getThemeColor(theme)
    let { style } = item

    const onSelect = () => {
        // console.log(`${config.basePath}/${item.linkUrl}`)
        // 判断是跳转站外还是站内，如果是站内则用router跳转，否则使用href跳转
        if (item.linkUrl && item.linkUrl.indexOf('http') === 0) {
            window.location.href = item.linkUrl;
        } else {
            // 这个页面因为跳转的是当前页面，只是改变了页面参数，所以使用history.push会导致页面内容不改变，只改变链接参数，所以这里使用href跳转
            window.location.href = `${config.basePath}${item.linkUrl}`
            // history.push(GRAPHIC_PATH(item.linkUrl));
        }
    }

    // console.log('item', item)

    return (
        <div onClick={onSelect} data-url={item.linkUrl} style={style}>
            <NETImage
                prefix={theme}
                src={item.imgUrl}
                className='Classify-item'
                useAutoHeight
                startHeight={item.startHeight}
            />
        </div>
    )
})